<div class="card w-full">
    <div class="flex justify-content-between p-4 pb-1">
        <div class="flex">
            <shared-sidebar/>
            <img src="/assets/logos/logoCamposol.png" alt="" width="120" height="40" class="hidden sm:block">
            <img src="/assets/logos/logo-conectados-sinfondo.png" alt="" width="30" height="30" class="block sm:hidden">
        </div>
        <div class="flex items-center gap-2">
            <div class="flex flex-column text-right mr-2">
                <span class="font-base">{{ store.user()?.name }}</span>
                <span class="text-xs text-gray-400">{{ store.user()?.rol }}</span>
                
                <!-- {{ store.user() | json }} -->
            </div>
            <p-button icon="pi pi-cog" styleClass="mr-1 surface-300 h-full" severity="secondary" />
            <p-button icon="pi pi-bell" styleClass="mr-1 surface-300 h-full" severity="secondary" />
            <div class="card flex justify-center">
                <p-menu #menu [model]="items" [popup]="true" />
                <p-button (click)="menu.toggle($event)" icon="pi pi-user" styleClass="h-full"/>
            </div>
        </div>
    </div>
</div>